import React, { useState } from 'react';
import cls from 'classnames';

import { IconComp } from '../IconComponent';

import { ReactComponent as ChevronRight } from '../../../assets/svg/icons/chevron-right.svg';

interface Question {
  title: string;
  answer: string;
}

export interface IFAQItem {
  question: Question;
}

export const FAQItem: React.FC<IFAQItem> = (props) => {
  const { question } = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      onClick={(): void => setIsOpen(!isOpen)}
      className="flex flex-col sk-cta mb-2 p-4 xs-only:p-2 bg-onion-50 border border-cloud-900 rounded-xl cursor-pointer transition ease-in-out duration-100"
    >
      <p className="flex justify-between items-center">
        <span className="text-cloud-900 font-normal text-lg xs-only:leading-6 xs-only:text-base">{question.title}</span>
        <IconComp className={cls({ 'transform rotate-90': isOpen })} icon={ChevronRight} size={24} />
      </p>
      {isOpen && (
        <div
          className="text-lg xs-only:text-base text-cloud-900 mt-4 xs-only:leading-6"
          dangerouslySetInnerHTML={{ __html: question.answer }}
        ></div>
      )}
    </div>
  );
};
